import { TvHistoryAggregationsHelper } from '../Helpers/TvHistoryAggregationsHelper';
import { TvUtcTimeZone } from './TvConstants';
import { VisiblePlotsSetEnum } from './TvEnums';
export class TvSymbol {
    constructor() {
        this.ticker = 'symbol name';
        this.name = 'name';
        this.description = 'description';
        this.type = 'type string';
        this.pricescale = 10; // Math.pow(10, presicion);
        this.volume_precision = 1;
        this.exchange = 'trading exchange name';
        this.listed_exchange = 'market exchange name';
        this.currency_code = ''; // the currency in which the instrument is traded or some other currency if currency conversion is enabled. It is displayed in the Symbol Info dialog and on the price axes
        this.original_currency_code = ''; // the currency in which the instrument is traded
        this.sector = 'sector';
        this.industry = 'industry';
        this.session = 'session string'; // '24x7'
        this.session_holidays = '';
        this.corrections = '';
        this.subsession_id = '';
        this.minmov = 1;
        this.minmove2 = 0;
        // supported_resolutions = [...TvChartSupportedResolutionArray] as ResolutionString[];
        this.seconds_multipliers = TvHistoryAggregationsHelper.getSecondsMultipliers();
        this.intraday_multipliers = TvHistoryAggregationsHelper.getIntradayMultipliers();
        this.daily_multipliers = TvHistoryAggregationsHelper.getDailyMultipliers();
        this.weekly_multipliers = TvHistoryAggregationsHelper.getWeeklyMultipliers();
        this.monthly_multipliers = TvHistoryAggregationsHelper.getMonthlyMultipliers();
        this.has_ticks = TvHistoryAggregationsHelper.hasTicks();
        this.has_seconds = TvHistoryAggregationsHelper.hasSeconds();
        this.has_intraday = TvHistoryAggregationsHelper.hasIntraday();
        this.has_daily = TvHistoryAggregationsHelper.hasDaily();
        this.has_weekly_and_monthly = TvHistoryAggregationsHelper.hasWeeklyAndMonthly();
        this.has_empty_bars = false;
        this.timezone = TvUtcTimeZone;
        this.visible_plots_set = VisiblePlotsSetEnum.ohlcv;
        this.data_status = 'streaming';
        this.delay = 0;
    }
}
